<template>
    <div class="selectedBlock selectedFutureBlock">
      <h3> 
        <span class="back" @click="$emit('clear-selected-future-block')">Back</span> 
         {{ordinal_suffix_of(index)}} next block
      </h3>
      <div class="block-info">
        <div class="info">
          <div><span>Median Fee</span> <span>{{Math.ceil(futureBlock.medianFee)}} sat/vB <span class="price">(${{price}})</span></span></div>
          <div><span>Fee span</span> <span> {{Math.round(futureBlock.feeRange[0])}} - {{Math.round(futureBlock.feeRange[futureBlock.feeRange.length - 1])}} sat/vB </span> </div>
          <div><span>Total fees</span> <span>{{addCommas(futureBlock.totalFees)}}</span></div>
          <div><span>Transactions</span> <span>{{addCommas(futureBlock.nTx)}}</span></div>
          <div><span>Filled</span>
            <div class="bar">
              <div class="filled" :style="{'width': (futureBlock.blockSize / FILLED_BLOCK_SIZE) * 100 + '%'}"></div>
              <div class="size" :style="{'width': (futureBlock.blockSize / FILLED_BLOCK_SIZE) * 100 + '%'}"> {{bytesToSize(futureBlock.blockSize)}} </div>
            </div>
          </div>
        </div>
        <div class="chart">
          <highcharts :options="feeRangeChartOptions" ref="feeRangeChart"></highcharts>
        </div>
      </div>
    </div>
</template>

<script>
import {Chart} from 'highcharts-vue'
import feeRangeChartOptions from './feeRangeChartOptions'

function ordinal_suffix_of(i) {
    let j = i % 10;
    let k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}

// 2MB
const FILLED_BLOCK_SIZE = 2097152;

export default {
  name:'selectedFutureBlock',
  props:['futureBlock', 'index', 'BTC_PRICE','darkTheme'],
  components: {
    highcharts: Chart,
  },
  watch:{
    futureBlock(newValue){
      if (newValue){
        feeRangeChartOptions.series[0].data = newValue.feeRange.map(item => Math.round(item));
      }
    },
    darkTheme(){
      this.checkChartColors(50)
    },
  },
  data: () => ({
    FILLED_BLOCK_SIZE:FILLED_BLOCK_SIZE,
    feeRangeChartOptions: feeRangeChartOptions,
  }),
  computed:{
    price(){
      return ((Math.ceil(this.futureBlock.medianFee) * 250 / 100000000) * this.BTC_PRICE).toFixed(2)
    }
  },
  methods:{
    ordinal_suffix_of :ordinal_suffix_of,
    checkChartColors(delay) {
      let lineColor = '#DDD9F9';
      let fontColor = '#141721';
      if (this.darkTheme){
        lineColor = '#3A4464';
        fontColor = '#FFFFFF';
      }
      setTimeout(()=> {
        this.feeRangeChartOptions.xAxis.gridLineColor = lineColor;
        this.feeRangeChartOptions.yAxis.gridLineColor = lineColor;
        this.feeRangeChartOptions.plotOptions.areaspline.dataLabels.style.color = fontColor;
      }, delay)
    }
  },
  mounted(){
    this.checkChartColors(0);
    this.feeRangeChartOptions.series[0].data = this.futureBlock.feeRange.map(item => Math.round(item));
  }
}
</script>

<style lang="scss" scoped>
.selectedFutureBlock{
  .block-info{
    .info{
      flex-direction: column;
      background: none !important;
      padding: 0 !important;
      & > div{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        background: var(--table-th-bg);
        border-radius: 2px;
        padding: 8px 14px;
        & > span:first-child{
          font-weight: 600;
        }
        .price{
          margin-left: 5px;
          color:#4BC79A;
        }
        .bar{
          width: 210px;
          height: 22px;
          background: rgba(68, 75, 255, 0.1);
          border: 1px solid rgba(56, 104, 248, 0.2);
          border-radius: 4px;
          position: relative;
          .filled{
            position: absolute;
            height: 20px;
            background: #444BFF;
            border-radius: 4px;
            max-width: 100%;
          }
          .size{
            position: absolute;
            min-width: 90px;
            max-width: 100%;
            color: #A9BEFF;
            height: 20px;
            line-height: 20px;
            text-align: center;
          }
        }
      }
    }
    .chart{
      background: transparent;
      padding-top: 0px;
      padding-bottom: 0px;
    }
  }
}

</style>